export const accessRight = {
  noAccess: 'no-access',
  read: 'ro',
  write: 'rw',
} as const

/**
 * - no-access: no access
 * - ro: read only
 * - rw: read and write
 *
 * Also contains "lumenaza" and "cloudinterface" but are unused in the app.
 */
export type AccessRight = (typeof accessRight)[keyof typeof accessRight]

export const allowAccess = (permission: AccessRight | null | undefined): boolean => {
  return permission !== 'no-access'
}
